import React, { Component } from "react";
import TopNav from "../containers/TopNav/TopNav";
import Footer from "../containers/Footer";
import CustomIcon from "../components/CustomIcon";
import AppWrapper from '../containers/AppWrapper';
class CustomIcons extends Component {
  render() {
    var icon = {
        fontSize: 14,
        textAlign: "center",
        padding: 16,
        borderRadius: 4,
        background: "#f4f4f4",
        margin: "8px 8px 8px 0",
        width: "23%",
        color: "#888888",
    };
    var wrapper = {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
    };
    return (
      <AppWrapper>
        <TopNav />
        <section>
            <div className="main-container">
                <div className="content-wrapper">
                    <h1>Custom Icons</h1>
                    
                    <div style={wrapper}>
                        <div style={icon}>
                            <CustomIcon name="agreement-outline" color="black" size="24" />
                            <div>agreement-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="agreement" color="black" size="24" />
                            <div>agreement</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="checkmark-outline" color="black" size="24" />
                            <div>checkmark-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="checkmark" color="black" size="24" />
                            <div>checkmark</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="boat-outline" color="black" size="24" />
                            <div>boat-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="boat" color="black" size="24" />
                            <div>boat</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="booking-calendar-outline" color="black" size="24" />
                            <div>booking-calendar-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="booking-calendar" color="black" size="24" />
                            <div>booking-calendar</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="cart-outline" color="black" size="24" />
                            <div>cart-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="cart" color="black" size="24" />
                            <div>cart</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="chat-outline" color="black" size="24" />
                            <div>chat-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="chat" color="black" size="24" />
                            <div>chat</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="clipboard-check-outline" color="black" size="24" />
                            <div>clipboard-check-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="clipboard-check" color="black" size="24" />
                            <div>clipboard-check</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="company-outline" color="black" size="24" />
                            <div>company-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="company" color="black" size="24" />
                            <div>company</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="facebook-outline" color="black" size="24" />
                            <div>facebook-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="facebook" color="black" size="24" />
                            <div>facebook</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="pinterest-outline" color="black" size="24" />
                            <div>pinterest-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="pinterest" color="black" size="24" />
                            <div>pinterest</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="linkedin-outline" color="black" size="24" />
                            <div>linkedin-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="linkedin" color="black" size="24" />
                            <div>linkedin</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="gopro-outline" color="black" size="24" />
                            <div>gopro-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="gopro" color="black" size="24" />
                            <div>gopro</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="hammer-outline" color="black" size="24" />
                            <div>hammer-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="hammer" color="black" size="24" />
                            <div>hammer</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="handshake-outline" color="black" size="24" />
                            <div>handshake-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="handshake" color="black" size="24" />
                            <div>handshake</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="leaf-outline" color="black" size="24" />
                            <div>leaf-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="leaf" color="black" size="24" />
                            <div>leaf</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="lightbulb-outline" color="black" size="24" />
                            <div>lightbulb-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="lightbulb" color="black" size="24" />
                            <div>lightbulb</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="megaphone-outline" color="black" size="24" />
                            <div>megaphone-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="megaphone" color="black" size="24" />
                            <div>megaphone</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="money-bills-outline" color="black" size="24" />
                            <div>money-bills-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="money-bills" color="black" size="24" />
                            <div>money-bills</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="money-outline" color="black" size="24" />
                            <div>money-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="money" color="black" size="24" />
                            <div>money</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="owning-circle" color="black" size="24" />
                            <div>owning-circle</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="owning-group-outline" color="black" size="24" />
                            <div>owning-group-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="owning-group" color="black" size="24" />
                            <div>owning-group</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="product-box-outline" color="black" size="24" />
                            <div>product-box-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="product-box" color="black" size="24" />
                            <div>product-box</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="roundcheck-outline" color="black" size="24" />
                            <div>roundcheck-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="roundcheck" color="black" size="24" />
                            <div>roundcheck</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="shop-outline" color="black" size="24" />
                            <div>shop-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="shop" color="black" size="24" />
                            <div>shop</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="storage-outline" color="black" size="24" />
                            <div>storage-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="storage" color="black" size="24" />
                            <div>storage</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="time-outline" color="black" size="24" />
                            <div>time-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="time" color="black" size="24" />
                            <div>time</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="traktor-outline" color="black" size="24" />
                            <div>traktor-outline</div>
                        </div>

                        <div style={icon}>
                            <CustomIcon name="traktor" color="black" size="24" />
                            <div>traktor</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Footer />
      </AppWrapper>
    );
  }
}

export default CustomIcons;
